module.exports = __webpack_public_path__ + "img/NF.53dc4c90.svg";